import { useRoute } from "wouter";

import OnboardingStep1 from "../components/onboarding/OnboardingStep1";
import OnboardingStep2 from "../components/onboarding/OnboardingStep2";
import OnboardingStep3 from "../components/onboarding/OnboardingStep3";
import OnboardingStep4 from "../components/onboarding/OnboardingStep4";
import OnboardingStep5 from "../components/onboarding/OnboardingStep5";
import OnboardingStepPhone from "../components/onboarding/OnboardingStepPhone";
import OnboardingStep6 from "../components/onboarding/OnboardingStep6";

const OnboardingPage = () => {
  const [, params] = useRoute("/onboarding/:step");
  const stepParam = params?.step;

  const steps = [
    { id: 'step-1', name: 'Welcome' },
    { id: 'step-2', name: 'Role' },
    { id: 'step-3', name: 'Experience' },
    { id: 'step-4', name: 'Industry' },
    { id: 'step-5', name: 'Goals' },
    { id: 'step-6', name: 'Nudges' },
    { id: 'step-7', name: 'Coach Match' },
  ];

  const currentStepIndex = steps.findIndex(s => s.id === stepParam);
  const progressPercentage = currentStepIndex >= 0 ? ((currentStepIndex + 1) / steps.length) * 100 : 0;

  const renderStep = () => {
    switch (stepParam) {
      case "step-1":
        return <OnboardingStep1 />;
      case "step-2":
        return <OnboardingStep2 />;
      case "step-3":
        return <OnboardingStep3 />;
      case "step-4":
        return <OnboardingStep4 />;
      case "step-5":
        return <OnboardingStep5 />;
      case "step-6":
        return <OnboardingStepPhone />;
      case "step-7":
        return <OnboardingStep6 />;
      default:
        return <div>Invalid Step</div>;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 font-sans">
      <div className="w-full max-w-2xl mx-auto">
        {/* Progress Bar */}
        <div className="mb-8">
          <div className="flex justify-between mb-1">
            <span className="text-base font-medium text-primary font-display">{steps[currentStepIndex]?.name || ''}</span>
            <span className="text-sm font-medium text-primary font-display">Step {currentStepIndex + 1} of {steps.length}</span>
          </div>
          <div
            className="w-full bg-gray-200 rounded-full h-2.5"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(progressPercentage)}
            aria-valuetext={`${Math.round(progressPercentage)}%`}
            aria-label="Onboarding progress"
          >
            <div
              className="bg-primary h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>

        {/* Step Content */}
        <div className="p-8 bg-white shadow-lg rounded-lg">
          {renderStep()}
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;
